<template>
<div class="container">
    <div class="row">
        <RegisterHeader />
        <BoxRegister>
            <div class="col-12 mt-2 ml-n2 px-0 pt-4 pb-5"> 
                <div class="col-12 row">
                    <h4 :class="`col-9 px-0 c-${getPrimaryColor}four bold`">
                        Hora de cadastrar seus sócios e procuradores!
                    </h4>
                    <HelpZipFiles class="col-3 pr-0" color="#727D94" v-if="enableComplementaryRegister" />
                </div>
                <p class="col-12 px-0 c-ndarkfour regular">
                    Agora que você nos informou os dados da sua empresa, falta pouco para finalizar seu cadastro!
                </p>
                <div v-if="enableComplementaryRegister">
                    <h5 class="mt-5 mb-3">
                        <ComplementaryRegistrationStar :primaryColor="getPrimaryColorHex.three" :secundaryColor="getPrimaryColorHex.one" :starColor="getPrimaryColorHex.four" class="mr-1" />
                        <span :class="`c-${getPrimaryColor}four`">
                            Cadastro complementar
                        </span>
                    </h5>
                    <p class="col-12 px-0 c-ndarkfour regular">
                        Continue complementando o seu cadastro! Ao fornecer mais alguns dados sobre a sua<br>
                        empresa e seus sócios, você garante <strong>acesso a todos os financiadores da plataforma.</strong><br>
                        Quanto mais informações forem preenchidas, mais propostas de financiamento podem ser<br>
                        recebidas!
                    </p>
                    <p class="c-nmidone medium mt-4">
                        SÓCIOS
                    </p>
                    <p class="col-12 px-0 c-ndarkfour medium">
                        Para complementar esta etapa do cadastro, você vai precisar adicionar:
                    </p>
                    <div class="row ml-1">
                        <div class="mt-3 py-2 pr-2 pl-4 partner-type-container">
                            <p class="c-ndarkfour medium my-3">
                                Sócio PF
                            </p>
                            <h6 class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Ficha cadastral PF preenchida;
                            </h6>
                            <h6 class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Declaração do imposto de renda.
                            </h6>
                        </div>
                        <div class="mt-3 mx-3 py-2 pr-2 pl-4 partner-type-container">
                            <p class="c-ndarkfour medium my-3">
                                Sócio PJ
                            </p>
                            <h6 class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Balanço dos últimos 24 meses;
                            </h6>
                            <h6 class="col-12 pl-0 pr-2 mt-2 mb-4 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>DRE dos últimos 24 meses.
                            </h6>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <h5 :class="`c-${getPrimaryColor}four mt-5 mb-3`">
                        <SimplifiedRegistrationPartner class="mr-1" :color="getPrimaryColorHex.four" :secundaryColor="getPrimaryColorHex.two" :circleColor="getPrimaryColorHex.one" :circleLineColor="getPrimaryColorHex.three"/> Cadastro simplificado
                    </h5>
                    <!--
                    <p class="col-12 px-0 c-ndarkfour regular">
                        Um cadastro simples para conseguir rápido acesso às opções de crédito de determinados <br>
                        financiadores da plataforma.
                    </p>
                    -->
                    <p class="col-12 mt-4 px-0 c-ndarkfour medium">
                        Para essa modalidade, você vai precisar de:
                    </p>
                    <div class="row ml-1">
                        <div class="mt-3 py-2 pr-2 pl-4 partner-type-container">
                            <p class="c-ndarkfour medium my-3">
                                Sócio PF
                            </p>
                            <h6 v-for="(document, index) in partnerDocuments" :key="index"  class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>{{ document.title }}
                            </h6>
                            <!--
                            <h6 class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>RG e CPF ou CNH vigente;
                            </h6>
                            <h6 class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Comprovante de residência;
                            </h6>
                            <h6 class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Certidão de casamento (se aplicável);
                            </h6>
                            <h6 class="col-12 pl-0 pr-2 mt-2 mb-n2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>RG e CPF ou CNH vigente do cônjuge
                            </h6>
                            <h6 class="col-12 pl-0 pr-2 mt-2 ml-4 mb-3 c-ndarkfour regular">
                                (se aplicável).
                            </h6>
                            -->
                        </div>
                        <div class="mt-3 mx-3 py-2 pr-2 pl-4 partner-type-container">
                            <p class="c-ndarkfour medium my-3">
                                Sócio PJ
                            </p>
                            <h6 v-for="(document, index) in partnerPjDocuments" :key="index"  class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>{{ document.title }}
                            </h6>
                            <!--
                            <h6 class="col-12 pl-0 pr-2 mt-2 mb-n2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Contrato Social e/ou última 
                            </h6>
                            <h6 class="col-12 pl-1 pr-2 mt-2 ml-4 c-ndarkfour regular">
                                atualização contratual;
                            </h6>
                            <h6 class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Ata de assembleia (se houver);
                            </h6>
                            <h6 class="col-12 pl-0 pr-2 mt-2 mb-4 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Cartão CNPJ.
                            </h6>
                            -->
                        </div>
                        <div class="mt-3 py-2 pr-2 pl-4 partner-type-container">
                            <p class="c-ndarkfour medium my-3">
                                Procuradores
                            </p>
                            <h6 v-for="(document, index) in partnerProcuratorDocuments" :key="index"  class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>{{ document.title }}
                            </h6>
                            <!--
                            <h6 class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Procuração Pessoa Física;
                            </h6>
                            <h6 class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>RG e CPF ou CNH;
                            </h6>
                            <h6 class="col-12 pl-0 pr-2 mt-2 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Comprovante de residência.
                            </h6>
                            <h6 class="col-12 pl-0 pr-2 mt-2 mb-4 c-ndarkfour regular">
                                <CheckPayment color="#33BDA3" class="mr-2" size="18"/>Certidão de casamento (se aplicável);
                            </h6>
                            -->
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-5 mb-5 px-0">
                    <Button @click="handleStartRegister" class="mr-3" :color="getPrimaryColor">
                        Iniciar cadastro
                    </Button>
                    <!--
                    <Button @click="downloadDocumentsPartner" type="outline" :color="getPrimaryColor" v-if="enableComplementaryRegister && getWhiteLabel == 'CASHFORCE'">
                        <Download size="12" :color="getPrimaryColorHex.four" /> Baixar fichas
                    </Button>
                    -->
                </div>
            </div>
        </BoxRegister>
    </div>
</div>
</template>

<script>
import BoxRegister from '@/components/box/BoxRegister'
import CheckPayment from '@/components/icons/CheckPayment'
import SimplifiedRegistrationPartner from '@/components/icons/SimplifiedRegistrationPartner'
import ComplementaryRegistrationStar from '@/components/icons/ComplementaryRegistrationStar'
//import Download from '@/components/icons/Download'
import HelpZipFiles from '@/components/register/HelpZipFiles'
import RegisterHeader from '@/components/register/RegisterHeader'
import getPartners from '@/api/getPartners'
import documentsList from '@/utils/documentsList'
import getWhiteLabel from '@/utils/getWhiteLabel'

export default {
    components: {
        BoxRegister,
        CheckPayment,
        SimplifiedRegistrationPartner,
        ComplementaryRegistrationStar,
        //Download,
        HelpZipFiles,
        RegisterHeader,
    },
    data() {
        return {
            backToCompanyHome: false,
            dialogVisible: false,
        }
    },
    methods: {
        downloadDocumentsPartner() {
            window.open('https://files.cashforce.com.br/fichas-cadastrais-socios.zip')
        },
        nextStep() {
            if (this.$route.path.includes('update')) {
                this.$router.push(`/provider/update/${this.$route.params.idCNPJ}/2`)
            } else {
                this.$router.push(`/provider/register/${this.$route.params.idCNPJ}/2`)
            }

        },
        handleStartRegister() {
            const routePrefix = `/company/register/${this.$route.params.idCNPJ}/partner`
            const partner = this.$store.state.register.partners.find(partners => partners.associateType != 'Procurador' && partners.name)
            this.$store.commit('register/setPartner', partner)
            if (partner) {
                if (this.enableComplementaryRegister && partner.associateType == 'Sócio' || partner.profession) return this.$router.push(`${routePrefix}/pf/${partner.id}/1`)
                if (this.enableComplementaryRegister && partner.associateType != 'Sócio') return this.$router.push(`${routePrefix}/pj/${partner.id}/2`)
            }
            this.$router.push(`/company/register/${this.$route.params.idCNPJ}/partner`)
        }
    },
    computed: {
        enableComplementaryRegister() {
            return !this.$store.state.user.userAdm
            && this.$store.state.user.companyType == '1'
            && this.$store.state.register.company.cnpj.registerComplete == 1
            && !this.$store.state.register.company.cnpj.complementaryRegister
        },
        partnerDocuments() {
            const whitelabel = getWhiteLabel(true) 
            let key = 'companyPartner'
            if (whitelabel === 'carbon') key += 'Carbon'
            if (whitelabel === 'universo') key += 'Universo'
            return documentsList[key]
        },
        partnerPjDocuments() {
            const whitelabel = getWhiteLabel(true) 
            let key = 'companyPartnerPj'
            if (whitelabel === 'carbon') key += 'Carbon'
            if (whitelabel === 'universo') key += 'Universo'
            return documentsList[key]
        },
        partnerProcuratorDocuments() {
            const whitelabel = getWhiteLabel(true) 
            let key = 'companyPartnerProcurator'
            if (whitelabel === 'carbon') key += 'Carbon'
            if (whitelabel === 'universo') key += 'Universo'
            return documentsList[key]
        },
    },
    async created() {
        if (this.enableComplementaryRegister) {
            await getPartners(this.$route.params.idCNPJ)
            this.$store.commit('register/resetPartner')
        }
    }
}
</script>

<style lang="scss" scoped>
.partner-type-container {
    width: 280px;
    border: 1px solid #DFE2EB;
    border-radius: 8px;
}

</style>
